import CategoryImageCarousel from "./CategoryImageCarousel.js";
import ItemStoreSpecial from "./ItemStoreSpecial.js";

Vue.component("category-item", {
    components: {
        CategoryImageCarousel,
        ItemStoreSpecial
    },

    props: {
        decimalCount:
        {
            type: Number,
            default: 0
        },
        imageUrlAccessor:
        {
            type: String,
            default: "urlMiddle"
        },
        itemData:
        {
            type: Object
        },
        disableCarouselOnMobile:
        {
            type: Boolean
        },
        paddingClasses:
        {
            type: String,
            default: null
        },
        paddingInlineStyles:
        {
            type: String,
            default: null
        }
    },

    jsonDataFields: [
        "itemDataRef"
    ],

    computed:
    {
        item()
        {
            let itemData = (this.itemData || this.itemDataRef);
            const beforePricesAvailability = $(this.$refs.beforePrices).find(".availability-id-storage");

            if (beforePricesAvailability.length > 0)
            {
                const availability = beforePricesAvailability.data("availability");

                itemData = { ...itemData, ...{ availabId: availability } };
            }

            return itemData;
        },

        /**
         * returns itemData.item.storeSpecial
         */
        storeSpecial()
        {
            return this.item.item.storeSpecial;
        },

        /**
         * returns itemData.texts
         */
        texts()
        {
            return this.item.texts;
        },

        itemPrice()
        {
            return this.$options.filters.specialOffer(this.item.prices.default.unitPrice.formatted, this.item.prices, "unitPrice", "formatted" );
        },

        itemSetPrice()
        {
            return this.$options.filters.currency(
                this.item.prices.default.price.value,
                this.item.prices.default.currency
            );
        },

        urlWithVariationId()
        {
            return !this.$ceres.config.item.showPleaseSelect || this.$ceres.initialPleaseSelect == 0;
        },

        ...window.Vuex.mapState({
            showNetPrices: state => state.basket.showNetPrices
        })
    },

    methods:
    {
        /**
         * returns the value of a variation property (group id 3) by its property id
         */
        getVariationProperty(propertyId)
        {
            const group = (this.item.variationProperties || []).find(g => g.id == 3);
            const property = group && group.properties.find(p => p.id == propertyId);

            return property ? property.values.value : "";
        }
    }
});
